import React from 'react'
import { cancelSubscriptionList } from '../../../../Profile/commands/subscriptions/cancel'
import {
  getCheckDate,
  getSubscriptionCreatedAt,
} from '../../../../Profile/commands/subscriptions/utils/getCheckDate'
import { Profile, Subscription } from '../../../../Profile/types'
import { UnitCancel, UnitMaster } from '../../../../Units/reducer'

export const onConfirmCancelSubscriptionCallback = ({
  selectedRow,
  profile,
  subscriptions,
  onCloseUnitModal,
}: {
  selectedRow: UnitMaster | null
  profile: Profile
  subscriptions: Subscription[]
  onCloseUnitModal: () => void
}) => {
  const selectedSubscription = React.useMemo(
    () =>
      subscriptions.find(
        (subscription) =>
          subscription.subscriptionId === String(selectedRow?.subscriptionId)
      ),
    [selectedRow?.subscriptionId, subscriptions]
  )

  const checkDate = getCheckDate(getSubscriptionCreatedAt(selectedSubscription))

  const onConfirmCancelSubscription = React.useCallback(async () => {
    if (!selectedRow) return
    const model: UnitCancel = {
      subscriptionId: String(selectedRow.subscriptionId),
      customerProfileId: profile.customerProfileId,
      phoneNumber: profile.phoneNumber,
      fullName: profile.fullName,
      email: profile.email,
      unitId: selectedRow.id,
      masterId: selectedRow.masterId,
      unitNumber: selectedRow.unitNumber,
      size: selectedRow.size,
    }
    model.lastPayment = checkDate.startOfMonth
    model.moveOut = checkDate.endOfMonth

    await cancelSubscriptionList(model).promise
    onCloseUnitModal()
  }, [checkDate, onCloseUnitModal, profile, selectedRow])

  return {
    onConfirmCancelSubscription,
  }
}
